var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"removable-input"},[_c('input',{attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":_vm.input}}),_c('div',{staticClass:"button remove-button"},[_c('Close',{attrs:{"size":16},on:{"click":_vm.remove}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }